// import React from 'react';
// import { Container } from "@mui/material";
// import { ConferenceContext } from '../../utils/globalStateContext';
// import PartnersComponent from './PartnersComponent';

// export default function Partners() {
//     const {Conference} = React.useContext(ConferenceContext);
//     return (
//         <div className="container">
//             <Container maxWidth="xl">
//                 <PartnersComponent eventID={Conference?.CurrentEventId}/>
//             </Container>
//         </div>
//     )
// }
export default function Partners(){
    return(
        <div></div>
    );
};